<template>
  <div class="h-100">
    <template v-if="exList.length">
      <div style="height: 160px;overflow-y:auto;">
        <div
          class="uk-flex uk-flex-between mb-10"
          v-for="ex in exList"
          :key="ex.id"
        >
          <div>{{ $timetransition(ex.recordTime) }}</div>
          <div v-if="ex.exCatalog === 1 && ex.exType !== 2  && ex.content">
            <span v-range="[ex.content.val, ex.content]"
              >{{ ex.content.val }}{{ ex.content.unit }}</span
            >
            ({{ ex.content.min }}{{ ex.content.unit }}~{{ ex.content.max
            }}{{ ex.content.unit }})
          </div>
          <div v-if="ex.exCatalog === 1 && ex.exType === 2  && ex.content">
            <span v-range="[ex.content.val, ex.content]">{{ formatTempValue(ex.content.val) }}{{ tempUnit }}</span>
            ({{ formatTempValue(ex.content.min) }}{{ tempUnit }}~{{ formatTempValue(ex.content.max) }}{{ tempUnit }})
          </div>
          <div v-else-if="ex.exCatalog === 0">
            {{ $t('integration.monitoring_device_connection_failure') }}
          </div>
          <div v-else>
            {{ $t('integration.standby_power_supply_for_device_startup') }}
          </div>
        </div>
      </div>
      <div class="uk-flex uk-flex-right">
        <Pagination
          class="pagination"
          :background="false"
          :total="total"
          layout="prev, pager, next"
          :page.sync="SearchForm.iDisplayStart"
          :iDisplayLength="SearchForm.iDisplayLength"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        >
        </Pagination>
      </div>
    </template>
    <template v-else>
      <el-empty :image-size="100"></el-empty>
    </template>
  </div>
</template>

<script>
import { getExRecordPage } from '@/api/modules/abnormal'
import { TempUtils } from '@/utils/TempUtil.js';
import { shareUnit } from '../../../../../api/modules/public'
import { getLanguage } from '@/lang';
export default {
  props: ['exId'],
  watch: {
    exId: {
      handler () {
        this.SearchForm.exId = this.exId
        this.getListFn()
      },
      immediate: true
    }
  },
  created () {
    this.UnitMeasurementFn();
  },
  data () {
    return {
      SearchForm: {
        iDisplayStart: 0,
        iDisplayLength: 5,
        exId: null
      },
      exList: [],
      tempUnit:'',
      total: 0
    }
  },
  methods: {
    UnitMeasurementFn () {
      shareUnit().then(({ result }) => {
        this.tempUnit = result.find(item => item.code === 'temp')?.name ?? '';
      })
    },
    formatTempValue(val) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'
      const result = TempUtils.convertToCelsius(numVal, this.tempUnit)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}`
    },
    getListFn () {
      getExRecordPage(this.SearchForm).then(({ result, pageInfo }) => {
        result = result.map(item => {
          if (item.content) {
            item.content = item.content.replace('\\', '')
            item.content = JSON.parse(item.content)
          }
          return item
        })
        this.total = pageInfo.total

        this.exList = result
      })
    }
  }
}
</script>
